export default __webpack_public_path__ + "static/media/banner2.85b1e989.png";